import React, { useMemo } from 'react';
import { useQuestionnaireContext } from '@/components/Questionnaire/QuestionnaireProvider';
import HandleAiAgentAutofill from './HandleAiAgentAutofill';

type Props = {
  filter: Parameters<typeof HandleAiAgentAutofill>[0]['filter'];
  onStartAgent: Parameters<typeof HandleAiAgentAutofill>[0]['onStartAgent'];
  questionnaireId: string;
};

const HandleAiAgentAutofills: React.FC<Props> = ({ filter, questionnaireId, onStartAgent }) => {
  const {
    aiAgents,
    aiAgentsReadyToRun,
  } = useQuestionnaireContext();

  const filteredAIAgents = useMemo(() => aiAgents?.filter((a) => a.isAutoRunEnabled) || [], [aiAgents]);

  if (!aiAgentsReadyToRun || filteredAIAgents.length === 0) {
    return <></>;
  }

  return (
    <>
      {
        filteredAIAgents.map((agent) => (
          <HandleAiAgentAutofill
            key={agent.id}
            aiAgent={agent}
            filter={filter}
            questionnaireId={questionnaireId}
            onStartAgent={onStartAgent}
          />
        ))
      }
    </>
  );
};

export default HandleAiAgentAutofills;
